import { DeliveryFilter } from "../types";
import { DeliveryListData, GetDeliveryParams } from "../types";
import { User } from "../../../auth/types";
import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { getParamsDateString } from "../../../../core/util/functions";

const getDeliveriesWebApi = (
  user: User,
  page: number,
  itemsPerPage: number,
  filter: DeliveryFilter
) => {
  const params: GetDeliveryParams = {
    userid: user.userId,
    fromrow: page * itemsPerPage,
    numofrows: itemsPerPage,
    sellerid: filter?.seller?.cliId,
    buyerid:filter?.buyer?.cliId,
    cliid:filter?.client?.cliId,
    prodid:filter?.product?.prodId,
    datefrom: getParamsDateString(filter.datefrom),
    dateto: getParamsDateString(filter.dateto),
  };

  return webApiWithResponse<DeliveryListData[]>({
    method: "GET",
    url: "clearing/getdlvrgoodslist",
    params,
  });
};

export default getDeliveriesWebApi;
